import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
type ProjectBrowserEmptyProps = {
  searchQuery?: string;
  hasFilters?: boolean;
};
export const ProjectBrowserEmpty: React.FC<ProjectBrowserEmptyProps> = t0 => {
  const $ = _c(11);
  const {
    searchQuery,
    hasFilters
  } = t0;
  const {
    LL
  } = useI18nContext();
  let t1;
  if ($[0] !== LL || $[1] !== hasFilters || $[2] !== searchQuery) {
    t1 = () => {
      if (searchQuery) {
        return LL.NO_PROJECTS_FOUND_FOR_SEARCH({
          query: searchQuery
        });
      }
      if (hasFilters) {
        return LL.NO_PROJECTS_MATCH_FILTERS();
      }
      return LL.NO_PROJECTS_FOUND();
    };
    $[0] = LL;
    $[1] = hasFilters;
    $[2] = searchQuery;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getMessage = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 200,
      p: 4
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "text.secondary"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== getMessage) {
    t5 = getMessage();
    $[7] = getMessage;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Box sx={t2}><Stack spacing={1} sx={t3}><Typography variant="body1" sx={t4}>{t5}</Typography></Stack></Box>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};